import React from 'react';
import { Button, UncontrolledTooltip } from 'reactstrap';

export const SIGNUP_DISABLED_MESSAGE =
  'New user? Make sure you are signing up in the right place. Contact your team leader or admin team to confirm your correct sign up link.';

export const DisabledCreateAccount: React.FunctionComponent<{
  id?: string;
}> = ({ id = 'create-account-disabled' }) => (
  <span>
    No Account?{' '}
    <span id={id} className="d-inline-block" style={{ cursor: 'not-allowed' }}>
      <Button color="link" disabled>
        Create Account
      </Button>
    </span>
    <UncontrolledTooltip target={id} placement="top">
      {SIGNUP_DISABLED_MESSAGE}
    </UncontrolledTooltip>
  </span>
);
